<script>
    import MonthInput from './MonthInput.svelte';

    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let family;
    export let editing = false;

    function submit(ev) {
        ev.preventDefault();
        dispatch('submit');
    }
    function cancel() {
        dispatch('cancel');
    }
</script>

<form on:submit={submit}>
    <input type=text bind:value={family.name}>
    <input type=number bind:value={family.maxPeople}>
    <input type=number bind:value={family.monthlyPayment}>

    <MonthInput bind:monthId={family.firstMonth} />

    <button type=submit>
        {#if editing}
            Upravit
        {:else}
            Vytvořit
        {/if}
    </button>
    <button type=button on:click={cancel}>Zrušit</button>
</form>